namespace('arctic.views.common');

compass.require('compass.show.ComingSoonWidget');
compass.require('compass.show.ClosedWidget');
compass.require('compass.show.LoginWidget');
compass.require('compass.account.ResetPasswordWidget');
compass.require('compass.arctic.InitialPopupDialogWidget');

arctic.views.common.entryPage = function(viewport, _viewInfo) {

	// starts measuring the time it takes for the view to load
	compass.startLoad('entryView');

	// :FORCED ERRROR: - for greping
	if ( window.location.href.indexOf("?throwAGodViewError") > 0 ){ var a = variable.that.doesnt.exist; }
	if ( window.location.href.indexOf("?throwAJAXError") > 0 ) { jQuery.ajax({ url: '/fakeEndPoint', type: 'POST', data: {}, success: function() {} }); }

	var _meetingInfo = _viewInfo.meetingInfo;
	var _initialHotel = _viewInfo.initialHotel;
	var _showResetForm = _viewInfo.showResetForm;

	var _viewport = viewport;
	var _data = {};

	var _container;
	var _popupContent;

	var $j = jQuery;
	var d = jQuery.dom;
	var googleTranslateOn = _viewInfo.meetingInfo.googleTranslateOn === "Y" ? true : false;

	var _handleCategorySelection = function (catdata) {
		var categorySelectionSuccess = function(catdata) {
			var passwordMessage = {
				pass: 'OK Password',
				fail: 'Incorrect Password'
			};

			if (catdata.passwordOK === true) {
				if ($j('.passwordMessage')) {
					$j('.passwordMessage').empty().append(passwordMessage.pass);
				}

				if(_container) {
					_container.remove();
					_container = null;
				}

				$j('#navBar').css('visibility', 'visible');
				$j('#header').css('visibility', 'visible');

				if(googleTranslateOn){
					$j('.background').css('z-index','');
					$j('.navBarLinks').css('display','');
					$j('.NavBarWidget').css('display','');
					$j('.HeaderWidget').css('display','');
					$j('.googleTranslateWrapper').css('margin-right','');
				}

				try{
					posthog.register ({categoryName : catdata.name});
				}catch(ex){}

				if(_initialHotel) {
					var _arrive = _viewInfo.arrive;
					var _depart = _viewInfo.depart;
					if (_arrive && _depart) {
						_viewport.trigger(CompassEvents.Navigate, 'hotelInfo/' + _initialHotel + '/' + _arrive + '/' + _depart);
					} else {
						_viewport.trigger(CompassEvents.Navigate, 'hotelInfo/' + _initialHotel);
					}
				} else {
					_viewport.trigger(CompassEvents.Navigate, 'hotels');
				}
			} else {
				$j('.passwordMessage').empty().append(passwordMessage.fail);
				$j('.password').val('');
			}
		};

		$j.ajax({
			url: '/categoryPassword',
			type: 'POST',
			data: catdata,
			success: categorySelectionSuccess
		});
	};

	var drawDialogHeader = function () {
		var addr = d.span({ className : 'showAddr' },
			d.span({ className : 'showCity' }, _meetingInfo.site.city)
		);
		if(_meetingInfo.site.state) {
			addr.append(d.span({ className : 'showState' }, ', ' + _meetingInfo.site.state));
		}
		if(_meetingInfo.site.country.toLowerCase() != 'united states') {
			addr.append(d.span({ className : 'showCountry' },
				', ' + _meetingInfo.site.country.toLowerCase()
			));
		}

		var headerImage = d.div({className:'eventHeaderImage'}, _meetingInfo.headerContent);
		headerImage.find("a, img").attr("tabindex", "-1");

		var showDetails = d.div({ className: 'showDetails secondaryText' },
			d.span({ className: 'showDates' }, _meetingInfo.datesDisplay ),
			d.span({ className: 'showVenue' }, _meetingInfo.site.name ),
			d.span({ className: 'showLocation' }, addr)
		);

		if(_meetingInfo.hideMeetingSubheader) {
			showDetails.empty();
		}

		return d.div({ className: 'showHeader', role: 'banner' },
			d.reader(_meetingInfo.name).attr('tabindex', '-1').addClass('focusHeader'),
			headerImage,
			d.div({className:'eventNameAndDetails'},
				d.h1({ className: 'showName notranslate' }, d.reader('Category selection and login.'),
				_meetingInfo.name
				),
				showDetails
			),
			d.div({className:'clear'})
		);
	};

	var _setupControls = function(data) {
		_popupContent = d.div({
			id : 'popupDiv',
			style : { display : 'none' }
		});
		_popupContent.show().empty();

		if (_showResetForm) {
			/*we are here if are logging in from a confo link for a user that that does not have a password defined*/
			var resetPassword = new compass.account.ResetPasswordWidget(_popupContent, {
				meetingInfo : _meetingInfo,
				showResetForm : true,
				onpeakID : _viewInfo.clientId,
				clientType : _viewInfo.clientType,
				officeName: data.office_name
			});
			_createDialog();
		} else if(!_meetingInfo.isOpen) {
			var comingSoon = new compass.show.ComingSoonWidget(_popupContent);
			comingSoon.bind('ComingSoonWidget.EmailSubmitted', function (event, data) {
				data.meeting_id = _meetingInfo.meeting_id;
				jQuery.ajax({
					url: '/comingSoon',
					data: data,
					success: comingSoon.showSuccess
				});
			});
			_createDialog();
		} else if (_meetingInfo.isOpen && _meetingInfo.isLookup) {
			var login = new compass.show.LoginWidget(_popupContent, {
				branchInfo: _viewInfo.branchInfo,
				meetingInfo: _meetingInfo
			});
			login.bind("LoginWidget.ForgotPasswordRequest", function (event) {
				_popupContent.empty();
				var resetPassword = new compass.account.ResetPasswordWidget(_popupContent, {
					meetingInfo : _meetingInfo,
					officeName: data.office_name
				});
			});
			_createDialog();
		} else if (!_meetingInfo.isOpen) {
			var closed = new compass.show.ClosedWidget(_popupContent);
			closed.bind('ClosedWidget.RequestLogin', function (event) {
				_popupContent.empty();
				var login = new compass.show.LoginWidget(_popupContent, {
					meetingInfo : _meetingInfo
				});

				login.bind("LoginWidget.ForgotPasswordRequest", function (event) {
					_popupContent.empty();
					var resetPassword = new compass.account.ResetPasswordWidget(_popupContent, {
						meetingInfo : _meetingInfo,
						officeName: data.office_name
					});
				});
			});
			_createDialog();
		} else if(typeof _viewInfo.login !== 'undefined') {
			/*we are here if we are logging in from a confo link for example but the user has a password already*/
			var login = new compass.show.LoginWidget(_popupContent, {
				branchInfo: _viewInfo.branchInfo,
				meetingInfo : _meetingInfo
			});
			login.bind("LoginWidget.ForgotPasswordRequest", function (event) {
				_popupContent.empty();
				var resetPassword = new compass.account.ResetPasswordWidget(_popupContent, {
					meetingInfo : _meetingInfo,
					officeName: data.office_name,
					onpeakID : _viewInfo.branchInfo.attendance_id || _viewInfo.branchInfo.group_id
				});
			});
			_createDialog();
		} else if (!data.category) {
			var hotelInfo = _.find(data.hotels, function(hotel) {
				return hotel.hotelId == _initialHotel;
			});
			var desiredCategory = _.find(data.categories, function(category) {
				return category.categoryId.toString() === data.categoryId.toString();
			});
			var categories = _.filter(data.categories, function(category) {
				if (desiredCategory && desiredCategory.hide_externally === true) {
					return category.categoryId.toString() === desiredCategory.categoryId.toString();
				} else {
					return category.hide_externally === false;
				}
			});
			var initial = new compass.arctic.InitialPopupDialogWidget(_popupContent, {
				WUID: 'CategoryPopup',
				categories: categories,
				meetingInfo : _meetingInfo,
				hotelInfo : hotelInfo,
				officeName: data.office_name,
				drawCopySection: !data.hideCategorySelectText
			});

			initial.bind("CategorySelect.categoryClicked", function(evt,catdata) {
				_handleCategorySelection(catdata);
			});
			initial.bind("InitialPopup.RequestLogin", function (event) {
				_popupContent.empty();
				_popupContent.append(d.reader(d.h2('Enter email and password to log in or reset password')));
				var login = new compass.show.LoginWidget(_popupContent, {
					meetingInfo : _meetingInfo,
					officeName: data.office_name
				});

				login.bind("LoginWidget.ForgotPasswordRequest", function (event) {
					_popupContent.empty();
					var resetPassword = new compass.account.ResetPasswordWidget(_popupContent, {
						meetingInfo : _meetingInfo,
						officeName: data.office_name
					});
				});
			});
			_createDialog();
		} else {
			_handleCategorySelection(data.category);
		}
	};

	function _createDialog() {
		var dialogContentsAttr = {
			className: 'popupDiv',
			role : 'main',
			'aria-role': 'main'
		};
		// change the url of the office logo
		var styleObject = {};
		if(_viewInfo.meetingInfo.officeLogos.OFFICE_LOGO_DARK && _viewInfo.meetingInfo.officeLogos.OFFICE_LOGO_DARK.url.length ){
			var backgroundUrl = "url('" + _viewInfo.meetingInfo.officeLogos.OFFICE_LOGO_DARK.url + "')";
			styleObject = {'background-image':backgroundUrl};
		}

		var dialogContents = d.div(dialogContentsAttr,
			drawDialogHeader(),
			_popupContent,
			// Only show office logo if redesign is NOT enabled
			(!compass.isRedesignEnabled() ? d.div({
				className : 'officeLevel_logo',
				style : styleObject,
				role : 'contentinfo',
				'aria-role' : 'contentinfo',
				'aria-label' : _viewInfo.meetingInfo.officeLogos.OFFICE_LOGO_DARK ? _viewInfo.meetingInfo.officeLogos.OFFICE_LOGO_DARK.title : ''
			}) : null),
			// Only show privacy policy link outside popup if redesign is NOT enabled
			( !compass.isRedesignEnabled() && _meetingInfo.privacyPolicyLink && _meetingInfo.privacyPolicyLink.length > 0 ? d.a({
				className : 'privacyPolicyLink',
				href : _meetingInfo.privacyPolicyLink,
				target : '_blank',
				style : {},
				role : 'contentinfo',
				'aria-role' : 'contentinfo',
				'aria-label' : 'privacy policy'
			}, 'terms of service and privacy policy') : null )
		);

		var backgroundImage;
		if (_meetingInfo.categoryBackgroundUrl === "") {
			backgroundImage = d.div({className: "background"}).css('background-image', 'url(' + compass.staticPrefix + '/resources/img/arctic/bgHero_CompassDemo1.jpg)');
		} else {
			backgroundImage = d.div({className: "background"}).css('background-image', 'url(' + _meetingInfo.categoryBackgroundUrl + ')');
		}

		_container = d.div({className: 'entryPopup'},
				backgroundImage,
				d.div({ className: "popup" }, dialogContents)
			);
		var popup = _container.find('.popup');

		_viewport.append(_container);

		if(googleTranslateOn){
			jQuery('.background').css('z-index','-1');
			jQuery('.navBarLinks').css('display','none');
			jQuery('.NavBarWidget').css('display','block');
			jQuery('.HeaderWidget').css('display','none');
			jQuery('.googleTranslateWrapper').css('margin-right','35px');
		}

		var center = function () {
			var h = jQuery(window).height(),
				w = jQuery(window).width();

			h -= popup.outerHeight();
			w -= popup.outerWidth();
			popup.css({
				top  : (h < 0 ? 0 : h/2),
				left : (w < 0 ? 0 : w/2)
			});
		};

		jQuery(window).bind('resize', center);
		center();

		_container.find('.focusHeader').focus();

		//_dialog = d.dialog({
			//contents : dialogContents,
			//modal: false,
			//showBackdrop: true,
			//backdropImageUrl:
			//role: false,
			//classes: 'entryPopup'
		//});
	}

	this.run = function(renderComplete) {
		$j('#viewport').trigger(CompassEvents.InvalidateView, 'hotels');
		compass.loading.start();
		jQuery.ajax({
			url : '/entry',
			data : { initialHotel : _initialHotel },
			success : function(data) {
				compass.loading.stop();
				if(data.bypassMobileCheck === false && _meetingInfo.allowMobileRedirect === true){
					var redirectAgents = [ "android","iphone","ipod" ];
					var uagent = navigator.userAgent.toLowerCase();
					var mobileURL = _meetingInfo.mobileURL;

					if (data.categoryId) {
						mobileURL = mobileURL + '&category_id=' + data.categoryId;
					}

					for (i=0;i<redirectAgents.length;i++){
						if(uagent.search(redirectAgents[i]) > -1){
							window.location.href=mobileURL;
						}
					}

				}
				if(data.validIndividualHousing) {
					_viewport.trigger(CompassEvents.Navigate, 'frontDesk');
					return;
				}
				else if(data.timeout) {
					return;
				}

				// stops measuring the time it takes the view to load
				compass.stopLoad('entryView');

				if (data.initialHotelId) {
					_initialHotel = data.initialHotelId;
				}

				if(data.passwordResetPrefill !== false) {
					_popupContent = d.div({
						id : 'popupDiv',
						style : { display : 'none' }
					});
					_popupContent.show().empty();

					var  login = new compass.show.LoginWidget(_popupContent, {
						branchInfo: _viewInfo.branchInfo
					});
					login.bind("LoginWidget.ForgotPasswordRequest", function (event) {
						_popupContent.empty();
						var resetPassword = new compass.account.ResetPasswordWidget(_popupContent, {
							meetingInfo : _meetingInfo,
							officeName: data.office_name
						});
					});
					login.trigger("LoginWidget.ForgotPasswordRequest");
					_createDialog();
					$('.pwResetForm .login').val(data.passwordResetPrefill);
				}
				else {
					var visibleCategories = _.filter(data.categories, function(cat) {
						return !cat.hide_externally;
					});

					var desiredCategory = _.find(data.categories, function(category) {
						return category.categoryId.toString() === data.categoryId.toString();
					});
					var desiredCategoryHasPassword = desiredCategory && desiredCategory.password;

					if(!desiredCategoryHasPassword && visibleCategories.length === 1 && visibleCategories[0].password === false && !window.location.hash){
						_viewport.trigger(CompassEvents.Navigate, 'hotels');
					}else{
						_setupControls(data);
						jQuery('.'+data.categoryId).activate();
					}
				}

				renderComplete();

				// have to track after view is tracked.
				if (!data.category) {
					/*we are here at the category selection*/
					compass.trackPageView("CategorySelection", {
						 src : 'arctic.views.common.entryPage',
						 automatic : true
					});
				}


			}
		});
	};

};
